import type {RecordClipboardService} from '../record-clipboard.service';
import type {Observable} from 'rxjs';
import type {RichRecord} from 'typings/portaro.be.types';
import type ToasterService from '../../../services/toaster-service';
import type {LocalizationService} from '../../../providers/localization.provider';

export class KpRecordClipboardButtonPresenter {
    public static presenterName = 'kpRecordClipboardButtonPresenter';

    /*@ngInject*/
    constructor(private recordClipboardService: RecordClipboardService,
                private toasterService: ToasterService,
                private localizationService: LocalizationService) {
    }

    public getRecords$(): Observable<RichRecord[]> {
        return this.recordClipboardService.getRecords$();
    }

    public addRecord(record: RichRecord) {
        this.recordClipboardService.add(record);
        this.toasterService.showInfo(this.localizationService.get(/* @kp-localization commons.Marked */ 'commons.Marked'));
    }

    public removeRecord(record: RichRecord) {
        this.recordClipboardService.remove(record);
        this.toasterService.showInfo(this.localizationService.get(/* @kp-localization commons.Demarked */ 'commons.Demarked'));
    }

    public canAddToClipboard(record: RichRecord): boolean {
        return !this.recordClipboardService.contains(record);
    }

    public canRemoveToClipboard(record: RichRecord): boolean {
        return this.recordClipboardService.contains(record);
    }
}